import React, { useEffect } from "react";
import styles from "./CalendlyWidget.module.css";

const CalendlyWidget = () => {
  const url =
    "https://www.calendly.com/ecaglasgow/30min?hide_gdpr_banner=1&utm_medium=website&utm_source=web&utm_campaign=”website%20promotion";
  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://assets.calendly.com/assets/external/widget.js";
    script.async = true;
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);
  return (
    <>
      <div
        data-url={url}
        className={["calendly-inline-widget", styles.calendlyWidget].join(" ")}
      ></div>
    </>
  );
};

export default CalendlyWidget;
